<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <div class="base-color mh-550 shadow">
      <div class="text-center p-4">
        <h2>画像アップロード</h2>
      </div>

      <div class="text-center m-5" v-if="mainMsg">
        <template v-for="(msg, index) in mainMsg">
          <p class="h5" :key="index">{{msg}}</p>
        </template>
        <b-spinner v-show="spinnerShow" class="mt-5"></b-spinner>
      </div>

      <div class="text-center m-5" v-else>
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="text-center mt-1 mb-3" v-if="isUploaded">
              <span class="h4">アップロードが完了しました</span>
            </div>
            <div class="text-center mt-1 mb-3">
              <span v-if="isUploaded">他の画像を送付いただく際は</span><br v-if="isUploaded" />
              <span>「画像を選択」ボタンを押して</span><br />
              <span>アップロードする画像を選択してください。</span>
            </div>

            <div class="text-center mb-2">
              <input type="file" ref="uploadImageInput" @change="uploadFile" class="d-none" multiple="multiple">
              <button class="btn main-color main-color-hover text-light" @click="uploadImageBtnClick">画像を選択</button>
            </div>
            <!-- localImageUrlに値が入ったら表示 -->
            <div class="m-auto" v-if="localImageUrl.length > 0">
              <div class="customer-upload-wait-image mx-w-575 mx-auto">
                <p>{{resizeImageCount}}枚選択中</p>
              </div>
              <div class="text-center mt-4 mb-3">
                <button class="btn main-button-color text-light" @click="sendUploadImage()" :disabled="uploadBtnDisabled">アップロード</button>
              </div>
            </div>
            <!-- localImageUrlに値がない場合は空白を表示 -->
            <div v-else>
              <div style="min-height: 300px;"></div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
    <div style="min-height:300px; display:none;" ref="container">
      <canvas :width="300" :height="200"></canvas>
    </div>
    <CommonModal ref="commonModal" />
    <CommonFunction ref="commonFunction" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CommonFunction from '@/components/CommonFunction'
import HashPasswordLoginModel from '@/models/HashPasswordLoginModel'
import BringImageModel from '@/models/BringImageModel'

export default {
  name: 'CustomerUploadImage',
  components: { CommonLayout, CommonModal, HashPasswordLoginModel, BringImageModel, CommonFunction },
  data () {
    return {
      overlayShow: false,
      isUploaded: false,
      localImageUrl: [],
      spinnerShow: true,
      mainMsg: [
        'ログイン中です。',
        'しばらくお待ち下さい'
      ],
      resizeImages: [],
      uploadBtnDisabled: true,
      resizeImageCount: 0,
      resizeCompleteCount: 0
    }
  },
  methods: {
    uploadFile () {
      if (this.$refs.uploadImageInput.files.length === 0) {
        this.$refs.commonModal.msgBoxOk('画像を選択してください')
        return false
      }

      const fileCount = this.$refs.uploadImageInput.files.length

      // 20枚以上の場合はバリデーションエラー
      if (fileCount > this.consts.maxUploadBringImageCount) {
        this.$refs.commonModal.msgBoxOk('登録可能なファイルは' + this.consts.maxUploadBringImageCount + '枚のみです。')
        this.uploadBtnDisabled = true
        return false
      }

      this.localImageUrl = []
      this.uploadBtnDisabled = true
      for (let i = 0; i < fileCount; i++) {
        let file = this.$refs.uploadImageInput.files[i]
        const extend = file.name.match(/[^.]+$/)[0]
        // 拡張子バリデーション
        // if (extend !== 'png' && extend !== 'jpg' && extend !== 'jpeg' && extend !== 'PNG' && extend !== 'JPG' && extend !== 'JPEG' && extend !== 'gif' && extend !== 'GIF' && extend !== 'webp' && extend !== 'WEBP' && extend !== 'heic' && extend !== 'HEIC' && extend !== 'heif' && extend !== 'HEIF') {
        //   this.$refs.commonModal.msgBoxOk('登録可能なファイル形式はjpeg・jpg・png・gif・webp・heic・heifのみです。')
        if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
          this.$refs.commonModal.msgBoxOk('登録可能なファイル形式はjpeg・jpg・png・gifのみです。')
          return false
        }
        this.beforeResizeImage(file, fileCount, this, i)
        // if (extend === 'heic' || extend === 'HEIC') {
        //   const heic2any = require('heic2any')
        //   let self = this
        //   heic2any({
        //     blob: file,
        //     toType: 'image/jpeg'
        //   })
        //     .then(function (resultBlob) {
        //       file = resultBlob
        //       self.beforeResizeImage(file, fileCount, self, i)
        //     })
        //     .catch(function (x) {
        //       console.log(x)
        //     })
        // } else {
        //   this.beforeResizeImage(file, fileCount, this, i)
        // }
        this.resizeImageCount = fileCount
      }
    },
    gcd (x, y) {
      if (y === 0) {
        return x
      }
      return this.gcd(y, x % y)
    },
    resizeImage (imageData, num, canvasWidth, canvasHeight) {
      const canvas = document.createElement('canvas')
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(imageData, 0, 0, canvasWidth, canvasHeight)

      this.resizeImages[num] = canvas.toDataURL('image/jpeg')

      canvas.height = 0
      canvas.width = 0
      canvas.remove()
      this.$delete(canvas)
      this.resizeCompleteCount++
    },
    sendUploadImage: async function () {
      this.overlayShow = true

      if (this.resizeImages.length === 0) {
        this.$refs.commonModal.msgBoxOk('サーバーへのアップロードに失敗しました\n最初からやり直してください')
        this.imageIni()
        return false
      }
      let fileSizeSum = 0
      let reqData = []
      reqData.push({'bringImages': [], 'totalBringImages': this.resizeImages.length})
      let reqDataNo = 0
      await this.resizeImages.forEach((base64FileStr, key) => {
        const file = this.$refs.uploadImageInput.files[key]

        if (!file || !file.name) {
          return false
        }

        if (!base64FileStr) {
          return false
        }

        // 画像アップロード用データ
        const imageData = {
          'bringImage': base64FileStr.replace(/^.*,/, ''),
          'fileName': file.name
        }
        if (imageData['bringImage'].length > 4000000) {
          this.$refs.commonModal.msgBoxOk('アップロード可能なファイルサイズ上限は4MBです。')
          this.imageIni()
          return false
        }
        fileSizeSum += imageData['bringImage'].length

        // 画像を4M以上送付しようとしているのであれば、4Mを超えないようにアップロード処理を行う
        if (fileSizeSum > 4000000) {
          reqData.push({ 'bringImages': [] })
          reqDataNo++
          fileSizeSum = 0
        }
        reqData[reqDataNo]['bringImages'].push(imageData)
      })
      // 画像アップロード処理
      this.isUploaded = false
      for (let reqKey = 0; reqKey < reqData.length; reqKey++) {
        const bringImageModel = await BringImageModel.apiSetStore(this.$bvModal, reqData[reqKey], () => {})

        if (!bringImageModel) {
          this.$refs.commonModal.msgBoxOk('アップロードに失敗しました')
          this.imageIni()
          return false
        }
        if (bringImageModel.status !== 'success' || bringImageModel.message) {
          this.$refs.commonModal.msgBoxOk(bringImageModel.message)
          this.imageIni()
          return false
        }
      }
      this.isUploaded = true
      this.imageIni()
    },
    uploadImageBtnClick () {
      this.$refs.uploadImageInput.click()
    },
    auth: async function () {
      try {
        const [projectNumber, hashPassword] = this.getProjectNumberAndPassword()
        await this.login(projectNumber, hashPassword)
        this.mainMsg = null
        return true
      } catch (err) {
        console.log(err)
        return false
      }
    },
    // エラー時などの共通処理
    authStop () {
      this.mainMsg = null
      this.mainMsg = Object.assign([], this.mainMsg, ['最初からやりなおしてください'])
      this.spinnerShow = false
    },
    // GETパラメータを取得
    getProjectNumberAndPassword () {
      if (!this.$route.query.projectNumber) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        this.authStop()
        throw new Error('auth error')
      }

      if (!this.$route.query.token) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        this.authStop()
        throw new Error('auth error')
      }

      return [this.$route.query.projectNumber, this.$route.query.token]
    },
    // login api 認証
    login: async function (projectNumber, hashPassword) {
      const reqData = {
        projectNumber: projectNumber,
        hashPassword: hashPassword,
        attendeeType: this.consts.attendeeType.customer
      }

      const hashPasswordLoginModel = await HashPasswordLoginModel.apiSetStore(this.$bvModal, reqData, null, (err) => {
        let errorMsg = 'エラーが発生しました'
        if (err.response && err.response.data && err.response.data.message) {
          errorMsg = err.response.data.message
        } else if (err.message) {
          errorMsg = err.message
        }
        this.$refs.commonModal.msgBoxOk(errorMsg)
        this.authStop()
        throw new Error('API error.')
      })

      // レスポンスが空の場合
      if (!hashPasswordLoginModel) {
        this.$refs.commonModal.msgBoxOk('ログイン処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      // レスポンスにメッセージが入ってる場合
      } else if (hashPasswordLoginModel.message) {
        this.$refs.commonModal.msgBoxOk(hashPasswordLoginModel.message)
        this.authStop()
        throw new Error('API error.')
      }
    },
    imageIni () {
      this.overlayShow = false
      this.localImageUrl = []
      this.resizeImages = []
      this.$refs.uploadImageInput.value = ''
    },
    beforeResizeImage (file, fileCount, self, i) {
      const image = new Image()
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        image.src = reader.result
        image.onload = (e) => {
          let canvasWidth = 0
          let canvasHeight = 0
          // 横幅と高さのいずれかが1280pxを超えている場合はリサイズ
          if (image.naturalWidth > 1280 || image.naturalHeight > 1280) {
            // アスペクト比計算
            const w = image.naturalWidth
            const h = image.naturalHeight
            const g = self.gcd(w, h)
            const ratioW = w / g
            const ratioH = h / g
            if (ratioW > ratioH) {
              // 横長画像(横幅 > 高さ)の場合
              canvasWidth = 1280
              canvasHeight = (1280 / ratioW) * ratioH
            } else {
              // 縦長画像(横幅 < 高さ)の場合
              canvasHeight = 1280
              canvasWidth = (1280 / ratioH) * ratioW
            }
          } else {
            canvasWidth = image.naturalWidth
            canvasHeight = image.naturalHeight
          }
          self.resizeImage(image, i, canvasWidth, canvasHeight)
          if (self.resizeCompleteCount === fileCount) {
            self.uploadBtnDisabled = false
            self.resizeCompleteCount = 0
          }
        }
      }
      self.localImageUrl.push(URL.createObjectURL(file))
    }
  },
  async mounted () {
    const isAuthEnable = await this.auth()
    // 認証成功
    if (isAuthEnable) {
      // GETパラメータをURLから削除
      this.$router.push({query: null})
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerUploadImage.vue